import styled from "styled-components";
import { COLORS, FontFamilyTypeEnum, Z_INDEX } from "../styled";

export const StoryPopupOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.55);
  z-index: ${Z_INDEX.HIGHEST + 2};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  box-sizing: border-box;
`;

export const StoryPopupCard = styled.div`
  width: 100%;
  max-width: 420px;
  max-height: min(92vh, 720px);
  overflow-y: auto;
  background: ${COLORS.WHITE};
  border-radius: 16px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.28);
  padding: 24px 20px 20px;
  box-sizing: border-box;
  text-align: center;
`;

export const StoryPopupImage = styled.img`
  display: block;
  width: calc(100% + 40px);
  max-height: 180px;
  margin: -24px -20px 16px;
  object-fit: cover;
  border-radius: 16px 16px 0 0;
`;

export const StoryPopupHeadline = styled.h2`
  margin: 0 0 10px;
  font-family: ${FontFamilyTypeEnum.MONTSERRAT};
  font-size: 20px;
  font-weight: 800;
  letter-spacing: 0.04em;
  color: #121B2F;
  text-transform: uppercase;
`;

export const StoryPopupBody = styled.p`
  margin: 0 0 18px;
  font-family: ${FontFamilyTypeEnum.MONTSERRAT};
  font-size: 14px;
  line-height: 1.45;
  font-weight: 500;
  color: #4A5568;
  text-align: left;
`;

export const StoryPrimaryButton = styled.button<{ $teamColor?: string }>`
  display: block;
  width: 100%;
  border: none;
  border-radius: 10px;
  padding: 14px 16px;
  background: ${({ $teamColor }) => $teamColor || "#121B2F"};
  color: ${COLORS.WHITE};
  font-family: ${FontFamilyTypeEnum.MONTSERRAT};
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
    cursor: default;
  }
`;

export const StoryLaterButton = styled.button`
  display: block;
  width: 100%;
  margin-top: 10px;
  border: none;
  background: transparent;
  padding: 8px;
  font-family: ${FontFamilyTypeEnum.MONTSERRAT};
  font-size: 13px;
  font-weight: 600;
  color: #6B7280;
  text-decoration: underline;
  cursor: pointer;
`;

export const StoryFieldLabel = styled.label`
  display: block;
  text-align: left;
  font-family: ${FontFamilyTypeEnum.MONTSERRAT};
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: #121B2F;
  margin: 0 0 6px;
`;

export const StoryTextArea = styled.textarea`
  display: block;
  width: 100%;
  min-height: 120px;
  box-sizing: border-box;
  margin-bottom: 14px;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  padding: 10px 12px;
  font-family: ${FontFamilyTypeEnum.MONTSERRAT};
  font-size: 14px;
  line-height: 1.4;
  color: #121B2F;
  resize: vertical;
`;

export const StoryInput = styled.input`
  display: block;
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 14px;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  padding: 10px 12px;
  font-family: ${FontFamilyTypeEnum.MONTSERRAT};
  font-size: 14px;
  color: #121B2F;
`;

export const StoryCheckboxRow = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  text-align: left;
  margin: 0 0 16px;
  font-family: ${FontFamilyTypeEnum.MONTSERRAT};
  font-size: 13px;
  font-weight: 500;
  color: #4A5568;
  cursor: pointer;

  input {
    margin-top: 2px;
    flex-shrink: 0;
  }
`;

export const StoryErrorText = styled.div`
  text-align: left;
  font-family: ${FontFamilyTypeEnum.MONTSERRAT};
  font-size: 12px;
  font-weight: 600;
  color: #b91c1c;
  margin: -8px 0 12px;
`;
